import { render } from "./ModalCardDetails.vue?vue&type=template&id=096e8579"
import script from "./ModalCardDetails.vue?vue&type=script&lang=js"
export * from "./ModalCardDetails.vue?vue&type=script&lang=js"

import "./ModalCardDetails.vue?vue&type=style&index=0&id=096e8579&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__